export default "__VITE_ASSET__C$oIW7la__"